import React from 'react';

import { useSelector } from 'react-redux';

import FieldText from '../commons/FieldText';
import FieldBirthday from '../commons/FieldBirthday';
import FieldSelect from '../commons/FieldSelect';

const GeneralData = () => {
  const genders = useSelector((state) => state.catalogs.genders);

  return (
    <div>
      <h3>Datos generales</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldText
          label="Nombre"
          name="name"
          required />
        <FieldText
          label="Apellido paterno"
          name="firstLastname"
          required />
      </div>
      <div className="field-row">
        <FieldText
          label="Apellido materno"
          name="secondLastname"
          required />
        <FieldText
          maxLength={13}
          label="RFC"
          name="rfc"
          required />
      </div>
      <div className="field-row">
        <div className="field -double-input">
          <FieldBirthday
            label="Fecha de nacimiento"
            name="birthdate"
            className="field -input -half"
            required />
        </div>
        <FieldSelect
          label="Género"
          required
          keyLabel="name"
          keyName="id"
          list={genders}
          className="field -input -half"
          name="gender" />
      </div>
    </div>
  );
};

export default GeneralData;
